/**
 * Pure scoping logic for cloning a LearnerTestProfile (PROC-190).
 *
 * A clone is scoped to the current prompt by default (only that
 * prompt's picker sees it) or, when the caller opts in, unscoped so it
 * shows up everywhere ("share with all prompts"). Extracted so this
 * decision — which directly controls whether test data leaks across
 * prompts — is covered independently of the dialog it's wired into.
 */
export function resolveCloneScopedKey(promptKey: string, global: boolean): string | null {
  return global ? null : promptKey;
}
